export default __webpack_public_path__ + "static/media/Drones_07.6d42cc38.png";